/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faChevronLeft, faTrashAlt, faSave } from '@fortawesome/free-solid-svg-icons';
import { PATH_DEFAULT } from '../../../routes';
import {
  EMPTY_STRING,
  FILE_REMOVE_MESSAGE,
  NAME_DEBOUNCE_VALUE,
  NAME_LEAVE_TIMEOUT
} from '../../../constants/constants';
import { formatNumericDateToString } from '../../../common/helpers/common.helpers';
import Button from '../../../common/components/button/button.component';
import TextArea from '../../../common/components/text-area/text-area.component';
import TextInputName from './text-input-name/text-input-name.component';
import Tags from '../../../common/components/tags/tags.component';
import InvalidNameConfirmation from './invalid-name-confirmation/invalid-name-confirmation.component';
import './file-details.style.scss';
import Audio from '../../../common/components/audio/audio.component';
import ProgressBar from '../../../common/components/progress-bar/progress-bar.component';

@inject('fileDetailsStore', 'filesStore', 'commonStore')
@observer
class FileDetails extends Component {

  static defaultProps = {
    commonStore: {
      openConfirmation: () => { },
    },
    fileDetailsStore: {
      file: {},
      tags: [],
      transcription: EMPTY_STRING
    },
    filesStore: {
      files: []
    }

  };

  static propTypes = {
    commonStore: PropTypes.shape({
      openConfirmation: PropTypes.func,
    }),
    fileDetailsStore: PropTypes.shape({
      downloadFileFromAmazon: PropTypes.func.isRequired,
      file: PropTypes.shape({}),
    }),
    filesStore: PropTypes.shape({
      files: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({}).isRequired,
  };


  state = {
    isNameConfirmationVisible: false
  };

  timer = null;

  /**
   * Loads file details based on path id.
   * */
  componentDidMount() {
    const { fileDetailsStore, match: { params: { id } } } = this.props;

    fileDetailsStore.loadFile(id);
  }

  /**
   * Resets the fileDetailsStore values.
   * */
  componentWillUnmount() {
    const { fileDetailsStore: { clear } } = this.props;

    clear();
  }

  /**
   * Navigates to previous page.
   * */
  handleGoBack = () => {
    const { history } = this.props;
    if (this.timer) {
      setTimeout(() => { history.push(PATH_DEFAULT); }, NAME_LEAVE_TIMEOUT);
      return;
    }
    history.push(PATH_DEFAULT);
  };


  /**
   * Update transcription text area.
   * React text area requires handle change event to be implemented
   * @param {object} event - The file event value.
   * */
  handleTranscriptionChange = (event) => {
    const { fileDetailsStore: { setTranscription } } = this.props;

    setTranscription(event.target.value);
  };

  /**
   * Sets new name and displays confirmation modal if name is not valid.
   * @param {object} name - The file name.
   * */
  handleNameChange = async (name) => {
    const {
      fileDetailsStore: { setName },
      filesStore: { setFileName },
      match: { params: { id } }

    } = this.props;

    await setName(name);

    const {
      fileDetailsStore: { suggestedName }
    } = this.props;

    if (suggestedName) {
      this.setState({ isNameConfirmationVisible: true });
    } else {
      setFileName(id, name);
    }
  };


  /**
   * Add tag to tags
   * @param {object} tag - The tag to add.
   * */
  handleTagAddition = (tag) => {
    const { fileDetailsStore: { addTag } } = this.props;

    const trimTag = tag.trim();
    if (trimTag) {
      addTag(trimTag);
    }
  };

  /**
   * Remove tag from tags
   * @param {object} tag - The tag to remove.
   * */
  handleTagDelete = (tag) => {
    const { fileDetailsStore: { removeTag } } = this.props;

    removeTag(tag);
  };

  /**
   * Sends updated file details to service.
   * */
  saveFileDetails = async () => {
    const { fileDetailsStore: { saveFileDetails } } = this.props;

    await saveFileDetails();
  };

  /**
   * Opens the confirmation popup for removing the file.
   * */
  handleRemove = () => {
    const { commonStore: { openConfirmation } } = this.props;

    openConfirmation(FILE_REMOVE_MESSAGE, this.onRemove);
  };

  /**
   * Removes the file.
   * */
  onRemove = async () => {
    const { fileDetailsStore: { removeFile } } = this.props;

    await removeFile();
    this.handleGoBack();
  };

  /**
   * Sets the suggested value as new name and clears suggested value
   * */
  onAcceptSuggestedName = async () => {
    const {
      fileDetailsStore: { clearSuggestedName, setName, suggestedName },
      filesStore: { setFileName },
      match: { params: { id } }
    } = this.props;

    await setName(suggestedName);
    setFileName(id, suggestedName);
    clearSuggestedName();
  };

  /**
   * Searches for file in list and returns isUploading state.
   * @param {array} files - List of files .
   * @param {object} id - The id to search for.
   * */
  isFileUploading = (files, id) => {
    /* TODO this method should be moved to files store.
       Remove files from props declaration
    */
    const currentUploadFile = files.find(file => file.id === id);
    return currentUploadFile && currentUploadFile.isUploading;
  };

  onCancel = async () => {
    this.setState({ isNameConfirmationVisible: false });
  };

  /**
   * Removes the file.
   * */
  onRemove = async () => {
    const { fileDetailsStore: { removeFile } } = this.props;

    await removeFile();
    this.handleGoBack();
  };

  /**
   * Catches the name change event and saves the value after a delay.
   * @param {string} value - the fle name.
   * */
  onHandleNameChange = (value) => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.handleNameChange(value);
    }, NAME_DEBOUNCE_VALUE);
  };

  /**
   * Triggers message zip and download to browser
   * */
  onFileDownload = async () => {
    const { fileDetailsStore: { downloadFileFromAmazon } } = this.props;

    await downloadFileFromAmazon();
  };

  render() {

    const innerheightcalc = window.innerHeight;
    const fileheightCalc = innerheightcalc * 0.76;
    const fileSectionStyle = {
      height: fileheightCalc+'px'
    };
    
    const {
      commonStore: {
        progress,
      },
      fileDetailsStore: {
        file: { id },
        file,
        name,
        suggestedName,
        tags,
        transcription
      },
      filesStore: {
        files
      }
    } = this.props;
    if (!id) return null;
    const isUploading = this.isFileUploading(files, id);

    const { isNameConfirmationVisible } = this.state;

    return (
      <div className="container-fluid">
        <div className="file-section container" style={fileSectionStyle}>
          <div className="file-header container">
            <div className="col-12 title-label">
              <label className="control-label">Title</label>
            </div>
            <div className="title-input">
              <Button
                fontAwesomeIcon={faChevronLeft}
                fontAwesomeSize="lg"
                buttonClass="btn btn-link float-left"
                onButtonClick={this.handleGoBack}
              />
              <TextInputName
                inputClass="form-control-lg"
                isError={!!suggestedName}
                onValueChange={this.onHandleNameChange}
                placeholder=""
                type="text"
                value={name}
              />
            </div>
          </div>
          <div className="file-form col-12">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-2 round-button">
                    <Audio hasProgressBar={true} url={file.download_url} isUploading={isUploading} />
                  </div>
                  <div className="col-10 detail-progress">
                    <ProgressBar width={progress} />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <label className="control-label float-left">Transcription</label>
                <TextArea
                  className="form-control"
                  onFocusOut={this.saveFileDetails}
                  onValueChange={this.handleTranscriptionChange}
                  value={transcription}
                />
              </div>
              <div className="col-12">
                <label className="control-label float-left">Tags</label>
                <Tags tags={tags} onAddition={this.handleTagAddition} onDelete={this.handleTagDelete} />
              </div>
              <div className="col-12">
                <label className="control-label float-left">Date added</label><br />
                <label>{formatNumericDateToString(file.created)}</label>
              </div>
            </div>
            {/* <div className="col-12">
              <div className="col-md-6 offset-md-3 col-sm-10">
                <button type="button" className="btn btn-outline-secondary round btn-block text-center" onClick={this.handleGoBack}>

                  <FontAwesomeIcon icon={faSave} size="lg"/>
                </button>
                <p className="sub-button">Return to Messages</p>
              </div>
            </div> */}
          </div>

        </div>
        <InvalidNameConfirmation
          isVisible={isNameConfirmationVisible}
          message={suggestedName}
          onCancel={this.onCancel}
          onConfirm={this.onAcceptSuggestedName}
        />

          <div className="footer-container">
            <div className="file-footer container-fluid">

                <div className="footer-wrapper col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
                  <div className="row">

                    <div className="col-3 text-center btn-div">
                      <button type="button" className="btn btn-link" onClick={this.onFileDownload}>
                      <FontAwesomeIcon icon={faCloudDownloadAlt} size="2x"/><br /><span>Download</span>
                    </button>
                    </div>
                    <div className="col-3 text-center btn-div">
                      <button type="button" className="btn btn-link" onClick={this.handleRemove}>
                      <FontAwesomeIcon icon={faTrashAlt} size="2x"/><br /><span>Remove</span>
                    </button>
                    </div>
                    <div className="col-3 text-center btn-div">
                      <button type="button" className="btn btn-link" onClick={this.handleGoBack}>
                      <FontAwesomeIcon icon={faSave} size="2x"/><br /><span>Save</span>
                    </button>
                    </div>

                  </div>
                  
                </div>
            </div>
          </div>

      </div>
    );
  }

}

export default FileDetails;



// WEBPACK FOOTER //
// ./src/messages/dashboard/file-details/file-details.component.js